import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as gridViewActions from 'common/components/grid-view/controllers/actions';
import selectorsGridView from 'common/components/grid-view/controllers/selectors';

import CategoriesControl from '../../controls/member-grid/CategoriesControl';
import { useUserInfo } from 'hooks';

const searchCategory = [
  'Automotive',
  'Beauty/Personal Care/Hygiene',
  'Camping',
  'Building Products',
];

const CategoriesSection = () => {
  const dispatch = useDispatch();

  const { userInfo } = useUserInfo();
  const searchCategories = userInfo?.searchCategories || searchCategory;

  const searchCategoriesEffected = useSelector(
    selectorsGridView.makeSelectSearchCategoriesList()
  );

  useEffect(() => {
    searchCategoriesEffected === null && // initial = null, if searchCategoriesEffected = null, make searchCategoriesEffected=[] in the first place
      dispatch(gridViewActions.setUserSearchCategoriesEffected([]));
  }, [searchCategories]);

  return (
    <CategoriesControl
      searchCategories={searchCategories}
      searchCategoriesEffected={searchCategoriesEffected}
    />
  );
};

export default CategoriesSection;
